(() => {
  const BUILT_IN_NIPPLES = [
    ...['Brass', 'Aluminum'].flatMap((material) => [16, 14, 12].map((length) => ({
      id: `sapim-double-square-polyax-${material.toLowerCase()}-${length}`,
      brand: 'Sapim',
      model: 'Double Square Polyax',
      material,
      length,
      nsdAddon: 2,
      washerCompatible: true,
      verified: length === 16,
      sourceUrl: length === 16
        ? 'https://www.starbike.com/manuals/wheel-spec-guide-46868-1767905484.pdf'
        : 'https://www.sheldonbrown.com/spoke-length.html'
    }))),
    ...['Brass', 'Aluminum'].flatMap((material) => [12, 14, 16].map((length) => ({
      id: `dt-swiss-standard-${material.toLowerCase()}-${length}`,
      brand: 'DT Swiss',
      model: 'Standard',
      material,
      length,
      nsdAddon: 2,
      washerCompatible: true,
      verified: false,
      sourceUrl: 'https://www.sheldonbrown.com/spoke-length.html'
    }))),
    ...['Brass', 'Aluminum'].map((material) => ({
      id: `dt-swiss-squorx-${material.toLowerCase()}-15`,
      brand: 'DT Swiss',
      model: 'Squorx',
      material,
      length: 15,
      nsdAddon: 2,
      washerCompatible: true,
      verified: false,
      sourceUrl: 'https://loamlabsusa.com/pages/spoke-calculator'
    })),
    ...['Brass', 'Alloy Pro 7'].flatMap((material) => [12, 14, 16].map((length) => ({
      id: `pillar-standard-${material.toLowerCase().replaceAll(' ', '-')}-${length}`,
      brand: 'Pillar',
      model: 'Standard',
      material,
      length,
      nsdAddon: 2,
      washerCompatible: true,
      verified: false,
      sourceUrl: 'https://www.sheldonbrown.com/spoke-length.html'
    }))),
    ...['Brass', 'Alloy Pro 7'].flatMap((material) => [14.4, 16, 18].map((length) => ({
      id: `pillar-dsn-${material.toLowerCase().replaceAll(' ', '-')}-${String(length).replace('.', '-')}`,
      brand: 'Pillar',
      model: 'DSN',
      material,
      length,
      nsdAddon: 2,
      washerCompatible: true,
      verified: false,
      sourceUrl: 'https://www.sheldonbrown.com/spoke-length.html'
    })))
  ];

  class WheelAssemblyCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.metaData = this.parseData('[data-wheel-metaobjects]');
      this.fallbackData = this.parseData('[data-wheel-fallback]');
      this.data = this.selectDataSources();
      this.form = this.querySelector('[data-wheel-form]');

      if (!this.form) return;

      this.elements = {
        rim: this.querySelector('[data-rim]'),
        position: this.querySelector('[data-position]'),
        hub: this.querySelector('[data-hub]'),
        hubBrand: this.querySelector('[data-hub-brand]'),
        hubModel: this.querySelector('[data-hub-model]'),
        hubBrake: this.querySelector('[data-hub-brake]'),
        holes: this.querySelector('[data-holes]'),
        spoke: this.querySelector('[data-spoke]'),
        nipple: this.querySelector('[data-nipple]'),
        offsetDirection: this.querySelector('[data-offset-direction]'),
        customHub: this.querySelector('[data-custom-hub]'),
        customLeftPcd: this.querySelector('[data-custom-left-pcd]'),
        customRightPcd: this.querySelector('[data-custom-right-pcd]'),
        customLeftCenter: this.querySelector('[data-custom-left-center]'),
        customRightCenter: this.querySelector('[data-custom-right-center]'),
        customSpokeHole: this.querySelector('[data-custom-spoke-hole]'),
        rimErd: this.querySelector('[data-rim-erd]'),
        rimNsd: this.querySelector('[data-rim-nsd]'),
        rimOffset: this.querySelector('[data-rim-offset]'),
        rimTension: this.querySelector('[data-rim-tension]'),
        leftLabel: this.querySelector('[data-left-label]'),
        rightLabel: this.querySelector('[data-right-label]'),
        leftOrder: this.querySelector('[data-left-order]'),
        rightOrder: this.querySelector('[data-right-order]'),
        leftExact: this.querySelector('[data-left-exact]'),
        rightExact: this.querySelector('[data-right-exact]'),
        leftQuantity: this.querySelector('[data-left-quantity]'),
        rightQuantity: this.querySelector('[data-right-quantity]'),
        targetTension: this.querySelector('[data-target-tension]'),
        balance: this.querySelector('[data-balance]'),
        eBikeRated: this.querySelector('[data-e-bike-rated]'),
        eBikeIcon: this.querySelector('[data-e-bike-icon]'),
        status: this.querySelector('[data-status]'),
        buildStatus: this.querySelector('[data-build-status]'),
        notice: this.querySelector('[data-notice]'),
        download: this.querySelector('[data-download]'),
        copy: this.querySelector('[data-copy]'),
        disclaimerGate: this.querySelector('[data-disclaimer-gate]'),
        disclaimerAcknowledge: this.querySelector('[data-disclaimer-acknowledge]'),
        hubTable: this.querySelector('[data-hub-table]'),
        hubFilterSearch: this.querySelector('[data-hub-filter-search]'),
        hubFilterBrand: this.querySelector('[data-hub-filter-brand]'),
        hubFilterPosition: this.querySelector('[data-hub-filter-position]'),
        hubFilterBrake: this.querySelector('[data-hub-filter-brake]'),
        hubFilterClear: this.querySelector('[data-hub-filter-clear]'),
        hubFilterCount: this.querySelector('[data-hub-filter-count]'),
        rimTable: this.querySelector('[data-rim-table]')
      };

      this.setupDisclaimerGate();
      this.renderRims();
      this.renderComponents();
      this.renderHubOptions();
      this.renderTables();
      this.setupHubFilters();
      this.applyRecommendedOffsetOrientation();
      this.updateFormState();

      this.form.addEventListener('submit', (event) => this.calculate(event));
      this.elements.rim?.addEventListener('change', () => {
        this.applyRecommendedOffsetOrientation();
        this.renderHubOptions();
        this.updateFormState();
        this.resetResults();
      });
      this.elements.position?.addEventListener('change', () => {
        this.applyRecommendedOffsetOrientation();
        this.renderHubOptions();
        this.updateFormState();
        this.resetResults();
      });
      this.elements.hubBrand?.addEventListener('change', () => {
        this.renderHubModels();
        this.renderHubBrakes();
        this.resolveHubSelection();
        this.updateFormState();
        this.resetResults();
      });
      this.elements.hubModel?.addEventListener('change', () => {
        this.renderHubBrakes();
        this.resolveHubSelection();
        this.updateFormState();
        this.resetResults();
      });
      this.elements.hubBrake?.addEventListener('change', () => {
        this.resolveHubSelection();
        this.updateFormState();
        this.resetResults();
      });
      this.elements.spoke?.addEventListener('change', () => this.resetResults());
      this.elements.nipple?.addEventListener('change', () => {
        this.updateFormState();
        this.resetResults();
      });
      this.elements.download?.addEventListener('click', () => window.print());
      this.elements.copy?.addEventListener('click', () => this.copyBuild());
    }

    setupHubFilters() {
      const filterElements = [
        this.elements.hubFilterSearch,
        this.elements.hubFilterBrand,
        this.elements.hubFilterPosition,
        this.elements.hubFilterBrake
      ].filter(Boolean);

      filterElements.forEach((element) => {
        element.addEventListener(element.tagName === 'INPUT' ? 'input' : 'change', () => this.filterHubTable());
      });

      this.elements.hubFilterClear?.addEventListener('click', () => {
        filterElements.forEach((element) => { element.value = ''; });
        this.filterHubTable();
        this.elements.hubFilterSearch?.focus();
      });

      this.filterHubTable();
    }

    setupDisclaimerGate() {
      const gate = this.elements.disclaimerGate;
      const acknowledge = this.elements.disclaimerAcknowledge;
      if (!gate || !acknowledge) return;

      const storageKey = 'tenet-wheel-calculator-acknowledged';
      const content = this.querySelectorAll('[data-calculator-content]');
      let acknowledged = false;

      try {
        acknowledged = window.sessionStorage.getItem(storageKey) === 'true';
      } catch (error) {
        acknowledged = false;
      }

      const setLocked = (locked) => {
        gate.hidden = !locked;
        content.forEach((element) => {
          element.inert = locked;
          if (locked) element.setAttribute('aria-hidden', 'true');
          else element.removeAttribute('aria-hidden');
        });
      };

      setLocked(!acknowledged);

      acknowledge.addEventListener('click', () => {
        try {
          window.sessionStorage.setItem(storageKey, 'true');
        } catch (error) {
          // The gate still unlocks when browser storage is unavailable.
        }
        setLocked(false);
        this.elements.rim?.focus();
      });
    }

    applyRecommendedOffsetOrientation() {
      if (!this.elements?.offsetDirection) return;

      const rim = this.selectedRim();
      const position = this.elements.position?.value;
      if (!rim || !position || Number(rim.offset) <= 0) {
        this.elements.offsetDirection.value = '';
        return;
      }

      this.elements.offsetDirection.value = position === 'front' ? 'right' : 'left';
    }

    parseData(selector) {
      const element = this.querySelector(selector);
      if (!element) return { rims: [], hubs: [], spokes: [], nipples: [] };

      try {
        const parsed = JSON.parse(element.textContent);
        return {
          rims: Array.isArray(parsed.rims) ? parsed.rims : [],
          hubs: Array.isArray(parsed.hubs) ? parsed.hubs : [],
          spokes: Array.isArray(parsed.spokes) ? parsed.spokes : [],
          nipples: Array.isArray(parsed.nipples) ? parsed.nipples : []
        };
      } catch (error) {
        console.error('Tenet wheel data could not be parsed.', error);
        return { rims: [], hubs: [], spokes: [], nipples: [] };
      }
    }

    selectDataSources() {
      const groups = ['rims', 'hubs', 'spokes', 'nipples'];
      const data = {};
      this.usingMetaobjects = false;

      groups.forEach((group) => {
        if (this.metaData[group]?.length) {
          data[group] = this.metaData[group];
          this.usingMetaobjects = true;
        } else {
          data[group] = this.fallbackData[group] || [];
        }
      });

      data.nipples = this.mergeNipples(BUILT_IN_NIPPLES, data.nipples || []);

      return data;
    }

    mergeNipples(primary, secondary) {
      const merged = new Map();
      [...primary, ...secondary].forEach((nipple) => {
        const key = [nipple.brand, nipple.model, nipple.material, nipple.length]
          .map((value) => String(value || '').trim().toLowerCase())
          .join('|');
        if (!merged.has(key)) merged.set(key, nipple);
      });
      return [...merged.values()];
    }

    nippleLabel(nipple) {
      const label = [nipple.brand, nipple.model, nipple.material, nipple.length ? `${nipple.length} mm` : '']
        .filter(Boolean)
        .join(' | ');
      return this.hasNsdAddon(nipple) ? label : `${label} | NSD data needed`;
    }

    renderRims() {
      this.replaceOptions(
        this.elements.rim,
        this.data.rims.map((rim) => ({ value: rim.id, label: `${rim.name} ${rim.size}`.trim() })),
        'No rim records',
        'Select rim'
      );
    }

    renderComponents() {
      this.replaceOptions(
        this.elements.spoke,
        this.data.spokes.map((spoke) => ({ value: spoke.id, label: `${spoke.brand} ${spoke.model}`.trim() })),
        'No spoke records',
        'Select spoke'
      );
      this.replaceOptions(
        this.elements.nipple,
        this.data.nipples.map((nipple) => ({ value: nipple.id, label: this.nippleLabel(nipple) })),
        'No nipple records',
        'Select nipple'
      );
    }

    renderHubOptions(preferredId = null) {
      const hubs = this.availableHubs();
      const previousId = preferredId || this.elements.hub?.value;
      const previousHub = this.data.hubs.find((hub) => String(hub.id) === String(previousId));
      const matchedHub = hubs.find((hub) => String(hub.id) === String(previousId)) ||
        hubs.find((hub) => previousHub && this.hubSignature(hub) === this.hubSignature(previousHub)) || null;

      const brands = [{ value: 'custom', label: 'Custom dimensions' }, ...this.uniqueOptions(hubs, (hub) => hub.brand)];
      this.replaceOptions(this.elements.hubBrand, brands, 'No hub records', 'Select hub brand');

      if (previousId === 'custom') {
        this.elements.hubBrand.value = 'custom';
        this.renderHubModels();
        this.renderHubBrakes();
        this.resolveHubSelection();
        return;
      }

      if (!matchedHub) {
        this.renderHubModels();
        this.renderHubBrakes();
        this.resolveHubSelection();
        return;
      }

      this.elements.hubBrand.value = matchedHub.brand;
      this.renderHubModels(this.hubModelLabel(matchedHub));
      this.renderHubBrakes(matchedHub.brake);
      this.resolveHubSelection(matchedHub.id);
    }

    availableHubs() {
      const position = this.elements.position?.value;
      const rim = this.selectedRim();
      if (!position || !rim) return [];
      return this.data.hubs.filter((hub) => {
        const positionMatches = String(hub.position || '').toLowerCase() === position;
        const drillingMatches = !rim || !Number(hub.holes) || Number(hub.holes) === Number(rim.holes);
        return positionMatches && drillingMatches;
      });
    }

    hubModelLabel(hub) {
      return String(hub?.model || '')
        .replace(/\s+(?:6[- ]?bolt|center\s*lock|6-lock\s*\/\s*center\s*lock)$/i, '')
        .trim();
    }

    hubSignature(hub) {
      return [hub?.brand, this.hubModelLabel(hub), hub?.brake].map((value) => String(value || '').toLowerCase()).join('|');
    }

    uniqueOptions(items, valueForItem) {
      const seen = new Set();
      return items.reduce((options, item) => {
        const value = String(valueForItem(item) || '').trim();
        if (!value || seen.has(value)) return options;
        seen.add(value);
        options.push({ value, label: value });
        return options;
      }, []);
    }

    renderHubModels(preferredModel = null) {
      const custom = this.elements.hubBrand?.value === 'custom';
      const hubs = this.availableHubs().filter((hub) => hub.brand === this.elements.hubBrand?.value);
      const options = this.uniqueOptions(hubs, (hub) => this.hubModelLabel(hub));
      this.replaceOptions(this.elements.hubModel, options, custom ? 'User supplied' : 'No models', custom ? null : 'Select hub model');
      this.elements.hubModel.disabled = custom || !options.length;
      if (preferredModel && options.some((option) => option.value === preferredModel)) this.elements.hubModel.value = preferredModel;
    }

    renderHubBrakes(preferredBrake = null) {
      const custom = this.elements.hubBrand?.value === 'custom';
      const hubs = this.availableHubs().filter((hub) =>
        hub.brand === this.elements.hubBrand?.value && this.hubModelLabel(hub) === this.elements.hubModel?.value
      );
      const options = this.uniqueOptions(hubs, (hub) => hub.brake || 'Not specified');
      this.replaceOptions(this.elements.hubBrake, options, custom ? 'User supplied' : 'No brake mounts', custom ? null : 'Select brake mount');
      this.elements.hubBrake.disabled = custom || !options.length;
      if (preferredBrake && options.some((option) => option.value === preferredBrake)) this.elements.hubBrake.value = preferredBrake;
    }

    resolveHubSelection(preferredId = null) {
      if (this.elements.hubBrand?.value === 'custom') {
        this.elements.hub.value = 'custom';
        return;
      }

      const matches = this.availableHubs().filter((hub) =>
        hub.brand === this.elements.hubBrand?.value &&
        this.hubModelLabel(hub) === this.elements.hubModel?.value &&
        String(hub.brake || 'Not specified') === this.elements.hubBrake?.value
      );
      const hub = matches.find((candidate) => String(candidate.id) === String(preferredId)) || matches[0] || null;
      this.elements.hub.value = hub?.id || '';
    }

    replaceOptions(select, options, emptyLabel, placeholderLabel = null) {
      if (!select) return;
      select.replaceChildren();

      if (placeholderLabel && options.length) {
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = placeholderLabel;
        placeholder.disabled = true;
        placeholder.selected = true;
        select.append(placeholder);
      }

      if (!options.length) {
        const option = document.createElement('option');
        option.value = '';
        option.textContent = emptyLabel;
        select.append(option);
        return;
      }

      options.forEach(({ value, label }) => {
        const option = document.createElement('option');
        option.value = value || '';
        option.textContent = label || emptyLabel;
        select.append(option);
      });
    }

    updateFormState() {
      const rim = this.selectedRim();
      const nipple = this.selectedNipple();
      const effectiveDiameter = this.calculationDiameter(rim, nipple);
      const position = this.elements.position?.value;
      const custom = this.elements.hub?.value === 'custom';

      if (this.elements.holes) this.elements.holes.value = rim?.holes ? `${rim.holes}H` : 'N/A';
      if (this.elements.rimErd) {
        this.elements.rimErd.textContent = !rim ? 'N/A' : effectiveDiameter ? `${this.formatNumber(effectiveDiameter)} mm` : 'Select nipple';
      }
      if (this.elements.rimNsd) this.elements.rimNsd.textContent = !rim ? 'N/A' : rim.nsd ? `${this.formatNumber(rim.nsd)} mm` : 'Not published';
      if (this.elements.rimOffset) this.elements.rimOffset.textContent = rim ? `${this.formatNumber(rim.offset || 0)} mm` : 'N/A';
      if (this.elements.rimTension) {
        const tension = rim?.targetMin && rim?.targetMax ? `${rim.targetMin}–${rim.targetMax} kgf` : rim?.maxTension ? `${rim.maxTension} kgf max` : 'N/A';
        this.elements.rimTension.textContent = tension;
      }

      if (this.elements.leftLabel) this.elements.leftLabel.textContent = position === 'rear' ? 'Left / disc / NDS' : position === 'front' ? 'Left / disc' : 'Left';
      if (this.elements.rightLabel) this.elements.rightLabel.textContent = position === 'rear' ? 'Right / drive' : position === 'front' ? 'Right / non-disc' : 'Right';
      if (this.elements.offsetDirection) {
        const leftOption = this.elements.offsetDirection.querySelector('option[value="left"]');
        const rightOption = this.elements.offsetDirection.querySelector('option[value="right"]');
        if (leftOption) leftOption.textContent = position === 'rear' ? 'Toward left / non-drive side' : position === 'front' ? 'Toward left / disc side' : 'Toward left';
        if (rightOption) rightOption.textContent = position === 'rear' ? 'Toward right / drive side' : position === 'front' ? 'Toward right / non-disc side' : 'Toward right';
      }

      if (this.elements.customHub) {
        this.elements.customHub.hidden = !custom;
        this.elements.customHub.open = custom;
      }
    }

    selectedRim() {
      return this.data.rims.find((rim) => String(rim.id) === String(this.elements?.rim?.value)) || null;
    }

    selectedHub() {
      if (this.elements.hub?.value === 'custom') {
        return {
          id: 'custom',
          brand: 'Custom',
          model: 'User supplied dimensions',
          position: this.elements.position?.value,
          standard: 'Custom',
          holes: Number(this.selectedRim()?.holes || 0),
          leftPcd: Number(this.elements.customLeftPcd?.value || 0),
          rightPcd: Number(this.elements.customRightPcd?.value || 0),
          leftCenter: Number(this.elements.customLeftCenter?.value || 0),
          rightCenter: Number(this.elements.customRightCenter?.value || 0),
          spokeHole: Number(this.elements.customSpokeHole?.value || 0),
          verified: false
        };
      }

      return this.data.hubs.find((hub) => String(hub.id) === String(this.elements.hub?.value)) || null;
    }

    selectedSpoke() {
      return this.data.spokes.find((spoke) => String(spoke.id) === String(this.elements.spoke?.value)) || null;
    }

    selectedNipple() {
      return this.data.nipples.find((nipple) => String(nipple.id) === String(this.elements.nipple?.value)) || null;
    }

    hasNsdAddon(nipple) {
      return nipple?.nsdAddon !== null && nipple?.nsdAddon !== '' && Number.isFinite(Number(nipple?.nsdAddon));
    }

    calculationDiameter(rim, nipple) {
      if (!rim || Number(rim.nsd) <= 0 || !this.hasNsdAddon(nipple)) return 0;
      return Number(rim.nsd) + (2 * Number(nipple.nsdAddon));
    }

    validateBuild(rim, hub, nipple) {
      const missing = [];
      if (!this.elements.position?.value) missing.push('a wheel position');
      if (!rim || Number(rim.nsd) <= 0 || Number(rim.holes) <= 0) missing.push('a complete rim NSD record');
      if (!hub || Number(hub.leftPcd) <= 0 || Number(hub.rightPcd) <= 0 || Number(hub.leftCenter) <= 0 || Number(hub.rightCenter) <= 0 || Number(hub.spokeHole) <= 0) {
        missing.push('complete hub geometry');
      }
      if (!nipple) missing.push('a nipple selection');
      else if (!this.hasNsdAddon(nipple)) missing.push('verified NSD geometry for the selected nipple');
      if (rim && hub && Number(hub.holes) && Number(hub.holes) !== Number(rim.holes)) missing.push('matching hub and rim drilling');
      if (rim && Number(rim.offset) > 0 && !this.elements.offsetDirection?.value) missing.push('rim offset orientation');
      return missing;
    }

    calculate(event) {
      event?.preventDefault();
      const rim = this.selectedRim();
      const hub = this.selectedHub();
      const spoke = this.selectedSpoke();
      const nipple = this.selectedNipple();
      const missing = this.validateBuild(rim, hub, nipple);

      if (missing.length) {
        this.setNotice(`Required: ${missing.join(', ')}.`, 'warning');
        this.setStatus('Incomplete build', 'warning');
        return;
      }

      const offset = Number(rim.offset || 0);
      const shift = this.elements.offsetDirection.value === 'right' ? offset : -offset;
      const leftCenter = Math.abs(Number(hub.leftCenter) + shift);
      const rightCenter = Math.abs(Number(hub.rightCenter) - shift);
      const effectiveDiameter = this.calculationDiameter(rim, nipple);
      const leftExact = this.spokeLength(effectiveDiameter, hub.leftPcd, leftCenter, rim.holes, hub.spokeHole);
      const rightExact = this.spokeLength(effectiveDiameter, hub.rightPcd, rightCenter, rim.holes, hub.spokeHole);
      const availableLengths = this.parseLengths(spoke?.lengths);
      const leftOrder = this.orderLength(leftExact, availableLengths);
      const rightOrder = this.orderLength(rightExact, availableLengths);
      const quantity = Number(rim.holes) / 2;
      const balance = this.tensionBalance(leftCenter, leftExact, rightCenter, rightExact);
      const geometryVerified = Boolean(rim.verified && hub.verified && hub.id !== 'custom');
      const componentVerified = Boolean((!spoke || spoke.verified) && (!nipple || nipple.verified));
      const fullyVerified = geometryVerified && componentVerified;

      this.elements.leftOrder.textContent = this.formatNumber(leftOrder);
      this.elements.rightOrder.textContent = this.formatNumber(rightOrder);
      this.elements.leftExact.textContent = `${leftExact.toFixed(1)} mm`;
      this.elements.rightExact.textContent = `${rightExact.toFixed(1)} mm`;
      this.elements.leftQuantity.textContent = `${quantity} + 2`;
      this.elements.rightQuantity.textContent = `${quantity} + 2`;
      this.elements.targetTension.textContent = rim.targetMin && rim.targetMax ? `${rim.targetMin}–${rim.targetMax} kgf` : `${rim.maxTension} kgf max`;
      this.elements.balance.textContent = `${balance}%`;
      this.elements.eBikeRated.dataset.state = spoke?.eBikeRated ? 'rated' : 'not-rated';
      this.elements.eBikeRated.setAttribute('aria-label', spoke?.eBikeRated ? 'E-bike rated' : 'E-bike rating not published');
      this.elements.eBikeIcon.textContent = spoke?.eBikeRated ? '✓' : '×';
      this.elements.buildStatus.textContent = fullyVerified ? 'Verified' : geometryVerified ? 'Geometry verified' : 'User supplied';
      this.elements.buildStatus.dataset.state = fullyVerified ? 'verified' : 'warning';
      this.setStatus(fullyVerified ? 'Verified' : geometryVerified ? 'Check components' : 'User supplied data', fullyVerified ? 'verified' : 'warning');

      const notes = [];
      if (!geometryVerified) notes.push('Hub geometry is user supplied or unverified.');
      if (!componentVerified) notes.push('Confirm the spoke and nipple manufacturer specifications.');
      if (!spoke?.eBikeRated) notes.push('The selected spoke does not have a published manufacturer e-bike rating.');
      if (rim.washerRequired && !nipple?.washerCompatible) notes.push('This rim requires a washer; the selected nipple is not marked washer compatible.');
      if (!notes.length) notes.push('All selected records are marked verified. Confirm dimensions against the physical components before ordering.');
      this.setNotice(notes.join(' '), notes.length > 1 || !fullyVerified ? 'warning' : 'normal');

      const position = this.elements.position.value;
      const leftName = position === 'rear' ? 'LEFT / DISC / NDS' : 'LEFT / DISC';
      const rightName = position === 'rear' ? 'RIGHT / DRIVE' : 'RIGHT / NON-DISC';
      const offsetOrientation = position === 'rear' ? 'nipple bed toward disc / NDS' : 'nipple bed toward non-disc / right';
      this.currentBuildText = [
        'TENET WHEEL ASSEMBLY',
        `${rim.name} ${rim.size} | ${position.toUpperCase()} | 3-CROSS`,
        `Rim: NSD ${rim.nsd} mm | nipple add-on ${Number(nipple.nsdAddon).toFixed(1)} mm per side | calculation diameter ${effectiveDiameter.toFixed(1)} mm | ${rim.holes}H | offset ${rim.offset || 0} mm | ${offsetOrientation}`,
        `Hub: ${hub.brand} ${hub.model} | ${hub.standard || ''}${hub.maxTension ? ` | ${hub.maxTension} kgf max` : ''}`,
        `${leftName}: calculated ${leftExact.toFixed(1)} mm | order ${this.formatNumber(leftOrder)} mm | qty ${quantity} + 2 spares`,
        `${rightName}: calculated ${rightExact.toFixed(1)} mm | order ${this.formatNumber(rightOrder)} mm | qty ${quantity} + 2 spares`,
        `Spoke: ${spoke ? `${spoke.brand} ${spoke.model}` : 'Not specified'}`,
        `E-bike rated: ${spoke?.eBikeRated ? 'Yes | selected spoke' : 'Not published'}`,
        `Nipple: ${nipple ? this.nippleLabel(nipple) : 'Not specified'}`,
        `Target tension: ${this.elements.targetTension.textContent} | expected balance ${balance}%`,
        `Status: ${this.elements.buildStatus.textContent}`,
        'Verify NSD, nipple geometry, and hub geometry against the physical components before ordering spokes.'
      ].join('\n');

      this.elements.download.disabled = false;
      this.elements.copy.disabled = false;
    }

    spokeLength(erd, flangePcd, centerToFlange, holes, spokeHoleDiameter) {
      const rimRadius = Number(erd) / 2;
      const flangeRadius = Number(flangePcd) / 2;
      const angle = (720 * 3 / Number(holes)) * (Math.PI / 180);
      const length = Math.sqrt(
        rimRadius ** 2 +
        flangeRadius ** 2 +
        Number(centerToFlange) ** 2 -
        2 * rimRadius * flangeRadius * Math.cos(angle)
      );
      return length - Number(spokeHoleDiameter || 0) / 2;
    }

    tensionBalance(leftCenter, leftLength, rightCenter, rightLength) {
      const leftLateralComponent = Number(leftCenter) / Number(leftLength);
      const rightLateralComponent = Number(rightCenter) / Number(rightLength);
      const ratio = rightLateralComponent / leftLateralComponent;
      const lowerToHigher = Math.min(ratio, 1 / ratio);
      return Math.round(lowerToHigher * 100);
    }

    parseLengths(value) {
      if (Array.isArray(value)) return value.map(Number).filter((number) => number > 0);
      const lengths = [];
      String(value || '').split(',').forEach((entry) => {
        const range = entry.trim().match(/^(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)$/);
        if (range) {
          const start = Number(range[1]);
          const end = Number(range[2]);
          for (let length = start; length <= end; length += 1) lengths.push(length);
          return;
        }

        const length = Number(entry.trim());
        if (length > 0) lengths.push(length);
      });
      return [...new Set(lengths)].sort((a, b) => a - b);
    }

    orderLength(exact, availableLengths) {
      if (!availableLengths.length) return Math.round(exact);
      return availableLengths.reduce((best, candidate) => {
        const candidateDelta = Math.abs(candidate - exact);
        const bestDelta = Math.abs(best - exact);
        if (candidateDelta < bestDelta) return candidate;
        if (candidateDelta === bestDelta && candidate > best) return candidate;
        return best;
      }, availableLengths[0]);
    }

    resetResults() {
      ['leftOrder', 'rightOrder', 'leftExact', 'rightExact', 'leftQuantity', 'rightQuantity', 'targetTension', 'balance'].forEach((key) => {
        if (this.elements[key]) this.elements[key].textContent = 'N/A';
      });
      this.elements.eBikeRated.dataset.state = 'pending';
      this.elements.eBikeRated.setAttribute('aria-label', 'E-bike rating pending');
      this.elements.eBikeIcon.textContent = 'N/A';
      this.elements.buildStatus.textContent = 'Unverified';
      this.elements.buildStatus.dataset.state = 'warning';
      this.setStatus('Awaiting calculation', 'warning');
      this.setNotice('Confirm the selected data and rim offset orientation, then calculate.', 'normal');
      this.elements.download.disabled = true;
      this.elements.copy.disabled = true;
      this.currentBuildText = '';
    }

    setStatus(text, state) {
      if (!this.elements.status) return;
      this.elements.status.textContent = text;
      this.elements.status.dataset.state = state;
    }

    setNotice(text, level) {
      if (!this.elements.notice) return;
      this.elements.notice.textContent = text;
      this.elements.notice.dataset.level = level;
    }

    async copyBuild() {
      if (!this.currentBuildText) return;
      try {
        await navigator.clipboard.writeText(this.currentBuildText);
        const previous = this.elements.copy.textContent;
        this.elements.copy.textContent = 'Copied';
        window.setTimeout(() => { this.elements.copy.textContent = previous; }, 1600);
      } catch (error) {
        console.error('Build details could not be copied.', error);
      }
    }

    renderTables() {
      if (this.elements.hubTable) {
        this.elements.hubTable.replaceChildren();
        this.renderHubFilterOptions();
        if (!this.data.hubs.length) {
          this.elements.hubTable.append(this.emptyRow(8, 'No verified hub records have been added yet. Custom dimensions remain available above.'));
        } else {
          this.data.hubs.forEach((hub) => {
            const row = document.createElement('tr');
            row.dataset.hubRow = '';
            row.dataset.brand = hub.brand || '';
            row.dataset.position = hub.position || '';
            row.dataset.brake = hub.brake || '';
            row.dataset.search = [hub.brand, hub.model, hub.position, hub.standard, hub.brake, hub.holes ? `${hub.holes}H` : '']
              .filter(Boolean)
              .join(' ')
              .toLowerCase();
            this.appendCells(row, [
              `${hub.brand} ${hub.model}`.trim(),
              hub.position || 'N/A',
              [hub.standard, hub.brake].filter(Boolean).join(' / ') || 'N/A',
              hub.holes ? `${hub.holes}H` : 'N/A',
              hub.leftPcd && hub.rightPcd ? `${hub.leftPcd} / ${hub.rightPcd} mm` : 'N/A',
              hub.leftCenter && hub.rightCenter ? `${hub.leftCenter} / ${hub.rightCenter} mm` : 'N/A',
              hub.maxTension ? `${hub.maxTension} kgf` : 'N/A',
              this.verificationLabel(hub)
            ], hub.sourceUrl);
            this.elements.hubTable.append(row);
          });

          const emptyFilterRow = this.emptyRow(8, 'No hubs match these filters.');
          emptyFilterRow.dataset.hubFilterEmpty = '';
          emptyFilterRow.hidden = true;
          this.elements.hubTable.append(emptyFilterRow);
        }
      }

      if (this.elements.rimTable) {
        this.elements.rimTable.replaceChildren();
        if (!this.data.rims.length) {
          this.elements.rimTable.append(this.emptyRow(7, 'No rim records have been added.'));
        } else {
          this.data.rims.forEach((rim) => {
            const row = document.createElement('tr');
            this.appendCells(row, [
              rim.name || 'N/A',
              rim.size || 'N/A',
              rim.nsd ? `${rim.nsd} mm` : 'Not published',
              `${rim.offset || 0} mm`,
              rim.holes ? `${rim.holes}H` : 'N/A',
              rim.targetMin && rim.targetMax ? `${rim.targetMin}–${rim.targetMax} kgf` : `${rim.maxTension || 'N/A'} kgf`,
              this.verificationLabel(rim)
            ], rim.sourceUrl);
            this.elements.rimTable.append(row);
          });
        }
      }
    }

    renderHubFilterOptions() {
      const populate = (select, values, initialLabel) => {
        if (!select) return;
        const currentValue = select.value;
        select.replaceChildren(new Option(initialLabel, ''));
        values.forEach((value) => select.add(new Option(value, value)));
        select.value = values.includes(currentValue) ? currentValue : '';
      };

      const brands = [...new Set(this.data.hubs.map((hub) => hub.brand).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b));
      const brakeMounts = [...new Set(this.data.hubs.map((hub) => hub.brake).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b));

      populate(this.elements.hubFilterBrand, brands, 'All brands');
      populate(this.elements.hubFilterBrake, brakeMounts, 'All mounts');
    }

    filterHubTable() {
      if (!this.elements.hubTable) return;

      const search = this.elements.hubFilterSearch?.value.trim().toLowerCase() || '';
      const brand = this.elements.hubFilterBrand?.value || '';
      const position = this.elements.hubFilterPosition?.value || '';
      const brake = this.elements.hubFilterBrake?.value || '';
      const rows = [...this.elements.hubTable.querySelectorAll('[data-hub-row]')];
      let visibleCount = 0;

      rows.forEach((row) => {
        const visible = (!search || row.dataset.search.includes(search))
          && (!brand || row.dataset.brand === brand)
          && (!position || row.dataset.position === position)
          && (!brake || row.dataset.brake === brake);
        row.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      const emptyRow = this.elements.hubTable.querySelector('[data-hub-filter-empty]');
      if (emptyRow) emptyRow.hidden = visibleCount !== 0;
      if (this.elements.hubFilterCount) {
        this.elements.hubFilterCount.textContent = `Showing ${visibleCount} of ${rows.length} hubs`;
      }
      if (this.elements.hubFilterClear) {
        this.elements.hubFilterClear.disabled = !search && !brand && !position && !brake;
      }
    }

    appendCells(row, values, sourceUrl) {
      values.forEach((value, index) => {
        const cell = document.createElement('td');
        if (index === values.length - 1 && sourceUrl) {
          const link = document.createElement('a');
          link.href = sourceUrl;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = value;
          cell.append(link);
        } else {
          cell.textContent = value;
        }
        row.append(cell);
      });
    }

    emptyRow(columns, message) {
      const row = document.createElement('tr');
      row.className = 'wheel-empty-row';
      const cell = document.createElement('td');
      cell.colSpan = columns;
      cell.textContent = message;
      row.append(cell);
      return row;
    }

    verificationLabel(item) {
      if (Object.prototype.hasOwnProperty.call(item, 'spokeHole') && Number(item.spokeHole) <= 0) return 'Needs spoke-hole Ø';
      if (!item.verified) return 'Unverified';
      return item.verifiedAt ? `Verified ${item.verifiedAt}` : 'Verified';
    }

    hasCompleteGeometry(hub) {
      return Number(hub.leftPcd) > 0 && Number(hub.rightPcd) > 0 && Number(hub.leftCenter) > 0 && Number(hub.rightCenter) > 0 && Number(hub.spokeHole) > 0;
    }

    formatNumber(value) {
      const number = Number(value);
      if (!Number.isFinite(number)) return 'N/A';
      return Number.isInteger(number) ? String(number) : number.toFixed(1);
    }
  }

  if (!customElements.get('wheel-assembly-calculator')) {
    customElements.define('wheel-assembly-calculator', WheelAssemblyCalculator);
  }
})();
